import { useEffect, useState } from "react"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import { FaSpinner, FaTimes, FaUser } from "react-icons/fa"
import { Button } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"

import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import listPlugin from "@fullcalendar/list";
import Tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import { getCurrentMonth } from "../utils/GetDates"


const CalendarioEventosLeads = () => {

  const [loading, setLoading] = useState(false)

  const [allEvents, setAllEvents] = useState([])
  const [totalDocs, setTotalDocs] = useState(0)

  const [searchCriteria, setSearchCriteria] = useState("leadName")
  const [leadName, setLeadName] = useState("")

  const [seller, setSeller] = useState("")
  const [eventType, setEventType] = useState("")
  const [eventSubType, setEventSubType] = useState("")

  const [workers, setWorkers] = useState([])

  const { start, end } = getCurrentMonth()

  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(() => {
    const date = new Date(end);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split('T')[0];
  })

  const getEvents = async () => {
    try {
      setLoading(true)
      let url = `${BACKEND}/api/eventosLeads?limit=0`
      let andFilters = [];

      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }
      if (leadName) {
        if (searchCriteria === "leadName") {
          url += `&where[lead.leadName][contains]=${leadName}`
        } else if (searchCriteria === "phone") {
          url += `&where[lead.phone][like]=${leadName}`
        } else if (searchCriteria === "dni") {
          url += `&where[lead.dni][like]=${leadName}`
        } else if (searchCriteria === "id") {
          url += `&where[lead][equals]=${leadName}`
        }
      }
      if (seller) {
        url += `&where[seller][equals]=${seller}`
      }
      if (eventType) {
        url += `&where[eventType][equals]=${eventType}`
      }
      if (eventSubType) {
        url += `&where[eventSubType][equals]=${eventSubType}`
      }
      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }
      const response = await axios.get(url)

      setAllEvents(response.data.docs)
      setTotalDocs(response.data.totalDocs)
    } catch (e) {
      return false
    } finally {
      setLoading(false)
    }
  }

  const getWorkers = async () => {
    try {
      //const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true&where[area][equals]=Comercial`)
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      const sellers = response.data.docs.filter((w) => w.area === "Comercial" || w.area === "Administracion" || w.puesto === "JEFE DE MARKETING")
      setWorkers(sellers)
    } catch (e) {
      console.log(e)
    }
  }

  const handleResetSearch = () => {
    setLeadName("")
  }

  useEffect(() => {
    getEvents()
    getWorkers()
  }, [])

  useEffect(() => {
    getEvents()
  }, [seller, eventType, eventSubType, startDate, endDate])

  const leadEventsForTable = allEvents.map((event) => {

    const isFirst = event.eventType === "Entrada al sistema";
    const isLast = event.isLast;

    // Definir colores según el tipo de evento
    let color = "white"; // Rojo por defecto
    let icon = "📌"; // Icono por defecto
    
    switch (event.eventType) {
      case "Entrada al sistema":
        color = "#7fdb1f"
        icon = "💻"; // Computadora para representar sistema
        break;
      case "Llamada":
        color = "#d3ccf1"
        icon = "📞"; // Teléfono
        break;
      case "Google Meet":
        color = "#73a6e4"
        icon = "📹"; // Cámara de video
        break;
      case "Cambio estado cotización":
        color = "#f0c83c"
        icon = "📝"; // Documento
        break;
    }

    return {
      id: event.id,
      title: `${icon} ${event.eventType || "Sin título"}`, // Agrega el icono al título
      leadName: event.lead?.leadName,
      start: event.createdAt,
      allDay: true,
      description: event.description || "",
      eventType: event.eventType || "Otro",
      isFirst,
      isLast,
      color,
      extendedProps: {
        leadName: event.lead?.leadName || "Desconocido",
        description: event.description || "Sin descripción",
        leadId: event.lead?.id,
        phone: event.lead?.phone
      }
    };
  });

  /// Mobile
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 900px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    };
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaUser className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Calendario de eventos</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Buscar por:</span>
              <select
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
                <option value="id">ID</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar lead"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={leadName}
                onChange={(e) => setLeadName(e.target.value)}
              />
              {leadName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => getEvents()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* FilterBar */}
      <div className="flex bg-gray-100 mt-1 mb-1 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-between overflow-x-auto px-4">
          <div className="flex bg-gray-100 mt-1 mb-1 w-full gap-10">
            <div className="flex flex-row w-full items-center justify-between overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="flex flex-row gap-4 items-center justify-center">
                    
                <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
                  <span className="truncate">Vendedor:</span>
                  <select
                    value={seller}
                    onChange={(e) => setSeller(e.target.value)}
                    className="w-[150px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
                  >
                    <option value="">Seleccionar</option>
                    {workers.map((worker) => (
                      <option value={worker.id}>{worker.name}</option>
                    ))}
                  </select>
                </div>
    
                <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
                  <span className="truncate">Tipo evento:</span>
                  <select
                    value={eventType}
                    onChange={(e) => setEventType(e.target.value)}
                    className="w-[200px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
                  >
                    <option value={""}>Seleccionar</option>
                    <option value={"Entrada al sistema"}>Entrada al sistema</option>
                    <option value={"Llamada"}>Llamada</option>
                    <option value={"Google Meet"}>Google Meet</option>
                    <option value={"Cambio estado cotización"}>Cambio estado cotización</option>
                  </select>
                </div>
    
                <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
                  <span className="truncate">Subtipo del evento:</span>
                  <select
                    value={eventSubType}
                    onChange={(e) => setEventSubType(e.target.value)}
                    className="w-[250px] text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
                  >
                    <option value={""}>Seleccionar</option>
                    {eventType === "Llamada" && (
                      <>
                        <option value={"Llamada perdida"}>Llamada perdida</option>
                        <option value={"Llamada corta"}>Llamada corta</option>
                        <option value={"Llamada fria"}>Llamada fria</option>
                        <option value={"Llamada atendida"}>Llamada atendida</option>
                      </>
                    )}
                    {eventType === "Google Meet" && (
                      <>
                        <option value={"Meet cancelado"}>Meet cancelado</option>
                        <option value={"Meet reagendado"}>Meet reagendado</option>
                        <option value={"Meet agendado"}>Meet agendado</option>
                        <option value={"Meet atendido"}>Meet atendido</option>
                      </>
                    )}
                    {eventType === "Cambio estado cotización" && (
                      <>
                        <option value={"Exito"}>Exito</option>
                        <option value={"Evaluando opciones"}>Evaluando opciones</option>
                        <option value={"Para el futuro"}>Para el futuro</option>
                        <option value={"Frio"}>Frio</option>
                        <option value={"Por confirmar depósito"}>Por confirmar depósito</option>
                        <option value={"Curioso"}>Curioso</option>
                        <option value={"No responde"}>No responde</option>
                        <option value={"El servicio le parece caro"}>El servicio le parece caro</option>
                        <option value={"Decidió trabajar con otra agencia"}>Decidió trabajar con otra agencia</option>
                        <option value={"Decidió trabajar con un freelancer"}>Decidió trabajar con un freelancer</option>
                        <option value={"No esta en mi ciudad"}>No esta en mi ciudad</option>
                        <option value={"Competencia o sospechoso"}>Competencia o sospechoso</option>
                        <option value={"Lead con poco presupuesto"}>Lead con poco presupuesto</option>
                      </>
                    )}
                  </select>
                </div>
    
              </div>
              <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
                <span className="truncate flex flex-row items-center justify-center gap-2">Total de eventos: {loading ? <FaSpinner className="animate-spin" /> : totalDocs}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Calendario */}
      {loading ? <LoadingScreen /> : (
        <div className="flex w-full gap-2 mt-4">
          <div className="px-4 flex-1">
            <FullCalendar
              events={leadEventsForTable}
              eventOrder={"order,start,-duration,title"}
              height="75vh"
              datesSet={(e) => {
                const viewStartDate = e.view.currentStart;
                const viewEndDate = e.view.currentEnd;
                
                // Restamos un día a la fecha final
                const adjustedEndDate = new Date(viewEndDate);
                adjustedEndDate.setDate(adjustedEndDate.getDate() - 1);

                setStartDate(viewStartDate.toISOString().split('T')[0])
                setEndDate(adjustedEndDate.toISOString().split('T')[0])
              }}         
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
                multiMonthPlugin,
              ]}
              moreLinkText={"Ver todos"}
              locale={"es"}
              headerToolbar={{
                start: isMobile ? "prev,next" : "title",
                center:
                  !isMobile &&
                  "multiMonthYear,dayGridMonth,listMonth",
                end: isMobile
                  ? "multiMonthYear,dayGridMonth,listMonth"
                  : "prev,next",
              }}
              buttonText={{
                today: "Hoy",
                month: "Mes",
                year: "Año",
                week: "Semana",
                day: "Día",
                listMonth: "Vista mes",
                listDay: "Vista hoy",
                timeGrid: "Semana",
              }}
              views={{
                timeGridFourDay: {
                  type: "timeGrid",
                  duration: { days: 4 },
                  buttonText: "Semana",
                },
                timeGridWeek: {
                  duration: { days: isMobile ? 4 : 7 },
                  buttonText: "Semana",
                },
              }}
              initialView={isMobile ? "timeGridWeek" : "dayGridMonth"}
              moreLinkHint={true}
              defaultAllDay
              dayMaxEvents={true}
              eventContent={function (arg) {
                let containerEl = document.createElement("div");
                containerEl.classList = `event-container cursor-pointer transition-all duration-100 border border-gray-300 rounded-md text-black ${arg.event.extendedProps.color}`;
                let contentEl = document.createElement("p");
                contentEl.classList = "event-content overflow-hidden";
                contentEl.innerHTML = `${arg.event.title} - ${arg.event.extendedProps.leadName} - ${arg.event.extendedProps.phone || 'Sin teléfono'}`;
                containerEl.appendChild(contentEl);
                containerEl.setAttribute("role", "link");
                containerEl.setAttribute("tabindex", "0");
                containerEl.addEventListener("click", () => {
                  window.open(`/home/trackeoLeads/${arg.event.extendedProps.leadId}`, '_blank');
                });

                return { domNodes: [containerEl] };
              }}
              eventDidMount={(info) => {
                Tippy(info.el, {
                  content: info.event.title,
                  placement: 'top',
                  theme: 'dark',
                  animation: 'scale'
                });
              }}
              initialEvents={[]}
            />

          </div>
        </div>
      )}

    </div>
  )
}

export default CalendarioEventosLeads
